import ModalBibliographyIntegration from '@/components/modals/ModalBibliographyIntegration/ModalBibliographyIntegration.vue'

export { ModalBibliographyIntegration }
